import { AuditLogsAdminList } from 'features';
import React from 'react';

const AuditLogsAdminPage = () => {
  return <AuditLogsAdminList />;
};

export default AuditLogsAdminPage;
